// extracted by mini-css-extract-plugin
module.exports = {"titleContainer":"ArticleListSection_titleContainer__20dq1","articles":"ArticleListSection_articles__wFVgO"};